import type { Drug } from "../types";

export const flucloxacillinDrug: Drug = {
  id: "flucloxacillin",
  name: "Flucloxacillin",
  drugClass: "penicillin",
  defaultFoodTiming: "Take 1 hour before or 2 hours after food",
  swallowingNote: "Capsules should be swallowed whole",
  sugarFreeNote:
    "Flucloxacillin sugar free oral solution may have a poor taste potentially leading to reduced compliance. After discussion with patient/carer consider sugar-containing preparation.",
  paediatricLinkRefs: [
    "medicines-for-children-fluclox",
    "medicines-for-children-giving-tablets",
    "medicines-for-children-giving-capsules",
  ],
  formulations: [
    {
      id: "fluclox-250-cap",
      type: "capsule_ir",
      strength: 250,
      strengthUnit: "mg",
      prescribedItemId: "99f54cd2-efd2-43a3-b1b1-1742373d4b8a",
    },
    {
      id: "fluclox-500-cap",
      type: "capsule_ir",
      strength: 500,
      strengthUnit: "mg",
      prescribedItemId: "4ebd0a95-910f-44a2-b379-97f1d7f60e25",
    },
    {
      id: "fluclox-125-5ml",
      type: "oral_solution",
      strength: 125,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "914b22ec-1eac-46b4-a0e0-0b433c1981c2",
    },
    {
      id: "fluclox-250-5ml",
      type: "oral_solution",
      strength: 250,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "f3448b61-66dc-4497-8f5a-79440334bc1d",
    },
  ],
};
